module.exports = __webpack_public_path__ + "img/744.6580ff17.jpg";